export const auth = {
  type: {
    freelance: 'freelance',
    client: 'client',
  },
}
